module.exports = __webpack_public_path__ + "static/media/Group 52965.9c58b0c6.svg";